// extracted by mini-css-extract-plugin
export default {"Row":"Row_Row__lx08F","Col":"Row_Col__4mFSV","Icons":"Row_Icons__gdD7R"};